import { GET_DRAFT_DOCUMENT } from "../services/get-draft-document";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_CONTENT_TYPES } from "../../../../pages/external-audit-setup/content-types/services/get-content-types";
import {
  assignVersionToList,
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../mdae-framework";
import { GET_ESMD_SUBMISSSIONS } from "../services/get-esmd-submission";
import { GET_CASE_NPI_OPTIONS } from "../services/get-case-npi-options";
import { cloneDeep } from "lodash";

export const SET_ESMD_CASE_DETAILS = "SET_ESMD_CASE_DETAILS";
export const SET_SELECTED_ESMD_DOCUMENT_LIST =
  "SET_SELECTED_ESMD_DOCUMENT_LIST";
export const RESET_IS_SELECT_ALL_DRAFT_DOCUMENTS =
  "RESET_IS_SELECT_ALL_DRAFT_DOCUMENTS";

export const SET_ESMD_SELECTED_TAB_INDEX = "SET_ESMD_SELECTED_TAB_INDEX";
export const SET_SUBMISSION_CONTENT_TYPE = "SET_SUBMISSION_CONTENT_TYPE";
export const SET_SELECTED_ESMD_SUBMISSION_ITEM =
  "SET_SELECTED_ESMD_SUBMISSION_ITEM";
export const TOGGLE_ESMD_SUBMISSION_WAIT_ALERT =
  "TOGGLE_ESMD_SUBMISSION_WAIT_ALERT";
export const SET_SUBMISSION_NPI = "SET_SUBMISSION_NPI";
const initialError = {
  code: "",
  message: "",
  value: [],
};
const initialState = {
  loading: false,
  error: initialError,
  draftDocumentList: [],
  selectedEsmdSubmissionDocList: [],
  contentTypeList: [],
  esmdSelectedTabIndex: 0,
  isSelectAllDraftDocuments: false,
  esmdSubmissionList: [],
  eaContentTypeId: 0,
  npiOptions: [],
  selectedNpi: "",
};

export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SET_ESMD_SELECTED_TAB_INDEX:
    case SET_SELECTED_ESMD_DOCUMENT_LIST:
      return {
        ...state,
        ...action.data,
        selectedEsmdSubmissionDocList:
          action.data.selectedEsmdSubmissionDocList,
      };

    case TOGGLE_ESMD_SUBMISSION_WAIT_ALERT:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const esmdUploadWaitWarnigPopupConfig = newState.esmdUploadWaitWarnigPopupConfig
          ? newState.esmdUploadWaitWarnigPopupConfig
          : {};
        for (let prop in action.data) {
          esmdUploadWaitWarnigPopupConfig[prop] = action.data[prop];
        }
        newState = {
          ...newState,
          esmdUploadWaitWarnigPopupConfig: esmdUploadWaitWarnigPopupConfig,
        };
      }
      return newState;
    case RESET_IS_SELECT_ALL_DRAFT_DOCUMENTS:
      return { ...state, isSelectAllDraftDocuments: false };
    case SET_SELECTED_ESMD_SUBMISSION_ITEM:
      return { ...state, selectedEsmdDocumentUploadId: action.data };
    case SET_SUBMISSION_CONTENT_TYPE:
      return { ...state, eaContentTypeId: action.data };
    case SET_SUBMISSION_NPI:
      return { ...state, selectedNpi: action.data };
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_DRAFT_DOCUMENT)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_DRAFT_DOCUMENT)(action)) {
        let newDraftDocList = action.response;
        return {
          ...state,
          draftDocumentList: assignVersionToList(newDraftDocList),
          loading: false,
          isSelectAllDraftDocuments: true,
          selectedEsmdSubmissionDocList: [],
        };
      }
      if (isAsyncOperation(GET_CONTENT_TYPES)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_CONTENT_TYPES)(action)) {
        return {
          ...state,
          contentTypeList: action.response,
          loading: false,
        };
      }
      if (isAsyncOperation(GET_ESMD_SUBMISSSIONS)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_ESMD_SUBMISSSIONS)(action)) {
        return {
          ...state,
          esmdSubmissionList: action.response,
          loading: false,
        };
      }
      if (isAsyncComplete(GET_CASE_NPI_OPTIONS)(action)) {
        return {
          ...state,
          npiOptions: action.response || [],
          loading: false,
        };
      }
      return state;
    default:
      return state;
  }
};
